import { render, staticRenderFns } from "./btn-icon-primary.vue?vue&type=template&id=00e726f8&scoped=true&"
import script from "./btn-icon-primary.vue?vue&type=script&lang=js&"
export * from "./btn-icon-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e726f8",
  null
  
)

export default component.exports